export default [
  {
    path: "/farmTechnologyInfo",
    name: "农技信息列表",
    component: () =>
      import("../views/farmTechnology/farmTechnologyInfo/Index.vue"),
  },
  {
    path: "/farmTechnologyAnswerer",
    name: "农技问答人员管理",
    component: () =>
      import("../views/farmTechnology/farmTechnologyAnswerer/index.vue"),
  },
];
